import { render, staticRenderFns } from "./RemoteConnectionHome.vue?vue&type=template&id=481e8be7&scoped=true&"
import script from "./RemoteConnectionHome.vue?vue&type=script&lang=ts&"
export * from "./RemoteConnectionHome.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481e8be7",
  null
  
)

export default component.exports